'use client'
import { storyblokEditable } from '@storyblok/react'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokListType } from '../../model/storyblokTypes.generated'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokList: FC<StoryblokComponentProps<StoryblokListType>> = ({
  blok,
}) => {
  return (
    <ul {...storyblokEditable(blok)} className="flex flex-col gap-3">
      <StoryblokComponentsRenderer bloks={blok.items} />
    </ul>
  )
}
